var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"divider-content"},[_c('h1',[_vm._v("Svi naši proizvodi su ručno pravljeni u malim serijama sa puno pažnje i ljubavi")]),_c('p',[_vm._v("Sve dok ne probate naše proizvode, ne mogu Vam dočarati o čemu je reč")])])
}]

export { render, staticRenderFns }